const Badge = {
    baseStyle: {
        bgColor: 'white',
        borderRadius: 'full',
        display: 'inline-block',
        fontFamily: 'body',
        fontSize: 'md',
        fontWeight: 'regular',
        padding: '2px var(--booking-engine-space-3)',
        textTransform: 'unset',
    },
    defaultProps: {},
    variants: {
        error: {
            bgColor: 'error.500',
            color: 'white',
        },
    },
};
export default Badge;
